// const baseUrl = "http://localhost:8000/api";
const baseUrl = "https://writeme-server.herokuapp.com/api";

export default baseUrl;
